import { render } from "./AddPriceGroupItemView.vue?vue&type=template&id=33ec02f8"
import script from "./AddPriceGroupItemView.vue?vue&type=script&lang=js"
export * from "./AddPriceGroupItemView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__